import { CountPicker, type CountPickerComponentProps } from "@tenant/ui";

export const GuestCountPicker = (props: CountPickerComponentProps) => (
  <CountPicker {...props} />
);
